import React from 'react';
import PropTypes from 'prop-types';
import Pic from 'core/components/ContentfulImage';

import {
	Frame,
} from './thumbStyles';

const PicThumb = ({ name, url, isCurrent, isLazy, ratio, soloItem }) => {
	return (
		<Frame isCurrent={isCurrent} ratio={ratio} soloItem={soloItem}>
			<Pic src={url} alt={name} title={name} lazy={isLazy} width="152" heigh="101" />
		</Frame>
	);
};

PicThumb.propTypes = {
	url: PropTypes.string.isRequired,
	name: PropTypes.string,
	trigger: PropTypes.func,
	isCurrent: PropTypes.bool,
	isLazy: PropTypes.bool,
	ratio: PropTypes.string,
	soloItem: PropTypes.bool,
};

export default PicThumb;
